"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DockerActions = tslib_1.__importStar(require("../modules/docker/actions"));
class BasePluginWindow {
    constructor(id, name, plugin) {
        this.id = id;
        this.name = this.name;
        this.plugin = plugin;
    }
    loadContent(content, isChildContent) {
        return content;
    }
    onAction(listener) {
        return listener;
    }
    getWindowInfo() {
        let result = null;
        const store = this.plugin.ide.getStore();
        if (store && store.getState) {
            const state = store.getState();
            if (state &&
                state.layout &&
                state.layout.window &&
                state.layout.window.items &&
                state.layout.window.items.has(this.id)) {
                result = state.layout.window.items.get(this.id);
            }
        }
        return result;
    }
    isVisible() {
        const info = this.getWindowInfo();
        return info ? info.isVisible : false;
    }
    isActive() {
        const info = this.getWindowInfo();
        return info ? info.isActive : false;
    }
    updateWindow(updatePayload) {
        const store = this.plugin.ide.getStore();
        if (store && store.dispatch) {
            store.dispatch(DockerActions.UpdateWindow(updatePayload));
        }
    }
    toggleLoadingAnimation(isLoading) {
        const info = this.getWindowInfo();
        if (info) {
            const store = this.plugin.ide.getStore();
            if (store && store.dispatch) {
                if (isLoading !== undefined) {
                    store.dispatch(DockerActions.UpdateWindow({ id: info.id, showLoading: isLoading }));
                    return;
                }
                store.dispatch(DockerActions.UpdateWindow({ id: info.id, showLoading: !info.showLoading }));
            }
        }
    }
}
exports.default = BasePluginWindow;
//# sourceMappingURL=BasePluginWindow.js.map